import * as actionTypes from '../actions/actionTypes';

const defaultState = {
    loading: false,
    selectedRows: [],
    rowDetail: null,
    data: [],
    pagination: { size: 25, skip: null },
    filters: [],
    filterOptions: [],
    sort: { columnName: 'createdon', sortOrder: 'desc' },

    columns: [],
    searchText: '',
    showNotes: false,
    showRecruiters: false
}

const newState = (state, newData) => {
    return Object.assign({}, state, newData)
}

const mydepartments = (state = defaultState, action) => {
    switch (action.type) {
        case actionTypes.SET_MYDEPARTMENTS_LOADING:
            return newState(state, {
                loading: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_SELECTEDROWS:
            return newState(state, {
                selectedRows: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_ROWDETAIL:
            return newState(state, {
                rowDetail: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_DATA:
            return newState(state, {
                data: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_PAGINATION:
            return newState(state, {
                pagination: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_FILTERS:
            return newState(state, {
                filters: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_SORT:
            return newState(state, {
                sort: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_FILTEROPTIONS:
            return newState(state, {
                filterOptions: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_COLUMNS:
            return newState(state, {
                columns: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_SEARCHTEXT:
            return newState(state, {
                searchText: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_SHOWNOTES:
            return newState(state, {
                showNotes: action.payload
            })
        case actionTypes.SET_MYDEPARTMENTS_SHOWRECRUITERS:
            return newState(state, {
                showRecruiters: action.payload
            })
        default:
            return state
    }
}
export default mydepartments;